
import * as React from "react";
import { cn } from "@/lib/utils";

export const SidebarMenuItem = React.forwardRef<
  HTMLLIElement,
  React.ComponentProps<"li">
>(({ className, ...props }, ref) => (
  <li
    ref={ref}
    data-sidebar="menu-item"
    className={cn("group/menu-item relative h-8", className)}
    {...props}
  />
));
SidebarMenuItem.displayName = "SidebarMenuItem";
